import _RentalCommissionApprovalService from "../services/rental-commission-approval-service";
import { IRentalCommissionApprovalService } from "../types/services/rental-commission-approval-service";

const RentalCommissionApprovalService: IRentalCommissionApprovalService = new _RentalCommissionApprovalService();

export default RentalCommissionApprovalService;
